@for(line of descriptionBlockConfig().lines; track line) {
<div>{{ line }}</div>
} 
@if(descriptionBlockConfig().button?.isNullOrEmpty() === false){
<a [href]="descriptionBlockConfig().button?.link" mat-flat-button class="button">
  {{ descriptionBlockConfig().button?.text }}
</a>
}
